export var mapLineItemDtoToViewModelMapper = function (lineItems) {
    return lineItems.map(function (_a) {
        var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity, taxes = _a.taxes, taxedTotal = _a.taxedTotal;
        var lineItemQuantity = quantity.serializedValue || 0;
        var lineItemPrice = price.serializedValue || 0;
        var lineItemTotal = lineItemQuantity * lineItemPrice;
        return {
            name: name,
            description: description,
            price: lineItemPrice,
            quantity: lineItemQuantity,
            total: lineItemTotal,
            taxes: taxes,
            taxedTotal: taxedTotal === null || taxedTotal === void 0 ? void 0 : taxedTotal.serializedValue,
        };
    });
};
//# sourceMappingURL=mapLineItemDtoToViewModel.mapper.js.map